import { render, staticRenderFns } from "./SpecialityModal.vue?vue&type=template&id=2bbf0c8b&"
import script from "./SpecialityModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SpecialityModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbf0c8b')) {
      api.createRecord('2bbf0c8b', component.options)
    } else {
      api.reload('2bbf0c8b', component.options)
    }
    module.hot.accept("./SpecialityModal.vue?vue&type=template&id=2bbf0c8b&", function () {
      api.rerender('2bbf0c8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/SpecialityFilters/components/SpecialityModal.vue"
export default component.exports